/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import {
  HttpClient,
  HttpEvent,
  HttpHeaders,
  HttpResponse
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';

import { Observable } from 'rxjs';

import { PageableRequest } from '../model/pageableRequest';
import { ResponseB4ACreditCardPayment } from '../model/responseB4ACreditCardPayment';
import { ResponseB4ACreditCardPaymentSummary } from '../model/responseB4ACreditCardPaymentSummary';
import { ResponseB4AListDropdownFilter } from '../model/responseB4AListDropdownFilter';
import { ResponseB4AObject } from '../model/responseB4AObject';
import { ResponseB4APagePaymentErrorDetail } from '../model/responseB4APagePaymentErrorDetail';

import { Configuration } from '../configuration';
import { BASE_PATH } from '../variables';

@Injectable()
export class PaymentControllerService {
  public configuration = new Configuration();

  public defaultHeaders = new HttpHeaders();
  protected basePath = 'http://localhost:8080';
  constructor(
    protected httpClient: HttpClient,
    @Optional() @Inject(BASE_PATH) basePath: string,
    @Optional() configuration: Configuration
  ) {
    if (basePath) {
      this.basePath = basePath;
    }
    if (configuration) {
      this.configuration = configuration;
      this.basePath = basePath || configuration.basePath || this.basePath;
    }
  }

  /**
   *
   *
   * @param creditCardPaymentId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findCreditCardPaymentById(
    creditCardPaymentId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACreditCardPaymentSummary>;
  public findCreditCardPaymentById(
    creditCardPaymentId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACreditCardPaymentSummary>>;
  public findCreditCardPaymentById(
    creditCardPaymentId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACreditCardPaymentSummary>>;
  public findCreditCardPaymentById(
    creditCardPaymentId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (creditCardPaymentId === null || creditCardPaymentId === undefined) {
      throw new Error(
        'Required parameter creditCardPaymentId was null or undefined when calling findCreditCardPaymentById.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4ACreditCardPaymentSummary>(
      'get',
      `${this.basePath}/payment/summary/${encodeURIComponent(String(creditCardPaymentId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param paymentId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findPaymentById(
    paymentId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4ACreditCardPayment>;
  public findPaymentById(
    paymentId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4ACreditCardPayment>>;
  public findPaymentById(
    paymentId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4ACreditCardPayment>>;
  public findPaymentById(
    paymentId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (paymentId === null || paymentId === undefined) {
      throw new Error(
        'Required parameter paymentId was null or undefined when calling findPaymentById.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4ACreditCardPayment>(
      'get',
      `${this.basePath}/payment/id/${encodeURIComponent(String(paymentId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param body
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public findPaymentErrorDetailPage(
    body: PageableRequest,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4APagePaymentErrorDetail>;
  public findPaymentErrorDetailPage(
    body: PageableRequest,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4APagePaymentErrorDetail>>;
  public findPaymentErrorDetailPage(
    body: PageableRequest,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4APagePaymentErrorDetail>>;
  public findPaymentErrorDetailPage(
    body: PageableRequest,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (body === null || body === undefined) {
      throw new Error(
        'Required parameter body was null or undefined when calling findPaymentErrorDetailPage.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined =
      this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.request<ResponseB4APagePaymentErrorDetail>(
      'put',
      `${this.basePath}/payment/error`,
      {
        body: body,
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getAllCreditCardPaymentTypes(
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AListDropdownFilter>;
  public getAllCreditCardPaymentTypes(
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AListDropdownFilter>>;
  public getAllCreditCardPaymentTypes(
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AListDropdownFilter>>;
  public getAllCreditCardPaymentTypes(
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AListDropdownFilter>(
      'get',
      `${this.basePath}/payment/type/all`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param creditCardPaymentId
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransactionByCreditCardPaymentId(
    creditCardPaymentId: number,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AObject>;
  public getTransactionByCreditCardPaymentId(
    creditCardPaymentId: number,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AObject>>;
  public getTransactionByCreditCardPaymentId(
    creditCardPaymentId: number,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AObject>>;
  public getTransactionByCreditCardPaymentId(
    creditCardPaymentId: number,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (creditCardPaymentId === null || creditCardPaymentId === undefined) {
      throw new Error(
        'Required parameter creditCardPaymentId was null or undefined when calling getTransactionByCreditCardPaymentId.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AObject>(
      'get',
      `${this.basePath}/payment/transaction/${encodeURIComponent(String(creditCardPaymentId))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   *
   *
   * @param gatewayId
   * @param tid
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public getTransactionByGatewayAndTID(
    gatewayId: number,
    tid: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ResponseB4AObject>;
  public getTransactionByGatewayAndTID(
    gatewayId: number,
    tid: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ResponseB4AObject>>;
  public getTransactionByGatewayAndTID(
    gatewayId: number,
    tid: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ResponseB4AObject>>;
  public getTransactionByGatewayAndTID(
    gatewayId: number,
    tid: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    if (gatewayId === null || gatewayId === undefined) {
      throw new Error(
        'Required parameter gatewayId was null or undefined when calling getTransactionByGatewayAndTID.'
      );
    }

    if (tid === null || tid === undefined) {
      throw new Error(
        'Required parameter tid was null or undefined when calling getTransactionByGatewayAndTID.'
      );
    }

    let headers = this.defaultHeaders;

    // authentication (bearer-key) required
    if (this.configuration.accessToken) {
      const accessToken =
        typeof this.configuration.accessToken === 'function'
          ? this.configuration.accessToken()
          : this.configuration.accessToken;
      headers = headers.set('Authorization', 'Bearer ' + accessToken);
    }
    // to determine the Accept header
    let httpHeaderAccepts: string[] = ['*/*'];
    const httpHeaderAcceptSelected: string | undefined =
      this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [];

    return this.httpClient.request<ResponseB4AObject>(
      'get',
      `${this.basePath}/payment/gateway/${encodeURIComponent(String(gatewayId))}/TID/${encodeURIComponent(String(tid))}`,
      {
        withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }
}
